import React, { memo } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import {
  Container,
  Row,
  Col,
  HeadingText,
  AccordionRow,
  Accordion,
  Link,
  BodyText,
} from '@paypalcorp/pp-react'
import { businessPageConfig } from '../../config/privacy-hub'
import serverData from '../../utils/server-data'

const customAccordion = (data) => {
  const { enabled, title, desc1, desc2, desc3, id } = data
  if (!enabled) {
    return null
  }
  return (
    <>
      <Row>
        <Accordion name="myAccordion">
          <AccordionRow
            headerClassName="privacy-hub-title-text"
            heading={<Message id={title} />}
            className="privacy-hub-accodion-col"
            id={id}
          >
            <BodyText className="privacy-hub-body-text" id={`${id}Desc1`}>
              <Message id={desc1} />
            </BodyText>
            {desc2 && (
              <BodyText
                className="privacy-hub-body-text privacy-hub-other-accord-description"
                id={`${id}Desc2`}
              >
                <Message
                  id={desc2}
                  link={(innerMessage) => (
                    <Link
                      href="/webapps/mpp/ua/privacy-full"
                      className="privacy-hub-hyper-link"
                      id={`${id}BusinessLink`}
                    >
                      {innerMessage}
                    </Link>
                  )}
                />
              </BodyText>
            )}
            {desc3 && (
              <BodyText
                className="privacy-hub-body-text privacy-hub-other-accord-description"
                id={`${id}Desc3`}
              >
                <Message id={desc3} />
              </BodyText>
            )}
          </AccordionRow>
        </Accordion>
      </Row>
    </>
  )
}

const PrivacyHubBusinessSection = memo(() => (
  <Container className="privacy-hub-business-section-container">
    <Row noGutters className="privacy-hub-align-items-center">
      <Col md={6} className="privacy-hub-col-spacing">
        <HeadingText
          size="hero"
          className="privacy-hub-display-text"
          id="privacyHubBusinessHeading"
        >
          <Message id="privacyhub.business.business.title" />
        </HeadingText>
      </Col>
      <Col
        xs={12}
        md={6}
        className="privacy-hub-business-image-container privacy-hub-text-align-center"
      >
        <img
          className="privacy-hub-business-image"
          src={`https://${serverData.cdnHostName}/privacyhub/private-business-illustration.svg`}
          alt="merchant"
        />
      </Col>
    </Row>
  </Container>
))

PrivacyHubBusinessSection.displayName = 'PrivacyHubBusinessSection'

const PrivacyHubAccordianSection = memo(() => (
  <Container className="privacy-hub-business-accordian-section-container">
    <Row noGutters>
      <Col md={6} className="privacy-hub-col-spacing">
        <HeadingText
          className="privacy-hub-business-page-title"
          id="privacyhubBusinessFaqsHeading"
        >
          <Message id="privacyhub.business.faq.title" />
        </HeadingText>
      </Col>
      <Col md={5} className="privacy-hub-accodion-col">
        {businessPageConfig.fqs.map((accordion, index) => {
          return <div key={index}>{customAccordion(accordion)}</div>
        })}
      </Col>
    </Row>
  </Container>
))

PrivacyHubAccordianSection.displayName = 'PrivacyHubAccordianSection'

const PrivacyHubBusiness = memo(() => (
  <div id="privacy-hub-business">
    <PrivacyHubBusinessSection />
    <PrivacyHubAccordianSection />
  </div>
))

PrivacyHubBusiness.displayName = 'PrivacyHubBusiness'

export default PrivacyHubBusiness
